/**
 * Carousel Lazy Load
 * @module patterns/components/carousels/carousel
 */

// Local Dependencies
import { App } from '~/app';
import { CLASS_NAME } from './constants';


export default function initialiseCarousel(app: App) {
    const elements: NodeListOf<Element> = document.querySelectorAll(`.${CLASS_NAME}`);

    let destroyCarousel = () => {};

    // No carousel items on load, return no-op.
    if (!elements.length) return destroyCarousel;

    import(/* webpackChunkName: "carousel" */ './carousel')
        .then(async ({ carousel }) => {
            await app.afterMount;

            const { elements, destroyCarousel: _destroyCarousel } = carousel();
            destroyCarousel = _destroyCarousel;

            // Notify the DOM that we've loaded
            elements.forEach((item) => {
                item.setAttribute('data-lazy', 'loaded');
            });
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Carousel component', error);
        });

    // Cleanup - `destroyCarousel` is updated at a later time, so we can't return it, but we can leverage closure to call it.

    return () => destroyCarousel();

}
